import { mergeWith } from 'lodash';
import dayjs from 'dayjs';

const mutations = {
  setList: (state, list) => {
    state.list = list;
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  setCondition: (state, condition) => {
    state.condition = condition;
  },
  setDetail: (state, detail) => {
    state.detail = detail;
    const { startDate, endDate } = detail;

    if (!!startDate && !!endDate)
      state.detail.usageDate = `${dayjs(startDate).format('YYYY-MM-DD')} ~ ${dayjs(endDate).format('YYYY-MM-DD')}`;
  }
};
export default mutations;
